import { ITranslations } from 'types/common';
import { UploadInputTransFields } from './types';
import en from 'translations/en/uploadInput.json';
import pl from 'translations/pl/uploadInput.json';
import sl from 'translations/sl/uploadInput.json';

export const uploadInputTranslations: ITranslations<UploadInputTransFields> = {
  name: 'uploadInput',
  en,
  pl,
  sl,
};
